export const PostgreSQLKeywords: string[] = [];
